// Activity forms shown during an outlet call.
// The server refuses to complete a call while a MANDATORY form is still unfilled and answers
// 400 {error: "activity_form_required", message, forms: [{id, name}]}.
export function activityFormRequired(err) {
  const d = err?.response?.data?.detail;
  return d && typeof d === "object" && d.error === "activity_form_required" ? d : null;
}

export const callFormsPath = (visitId, extra = "") => `/field/call-forms/${visitId}${extra}`;

// When a call is closed WITHOUT an order and a mandatory form is still unfilled, the reason the user
// already chose is remembered here, so after filling the form the call completes with that same
// reason instead of asking for it a second time.
const key = (visitId) => `tulsi:pending-close:${visitId}`;
export function savePendingClose(visitId, fields) {
  try { sessionStorage.setItem(key(visitId), JSON.stringify(fields)); } catch { /* private mode */ }
}
export function readPendingClose(visitId) {
  try { return JSON.parse(sessionStorage.getItem(key(visitId)) || "null"); } catch { return null; }
}
export function clearPendingClose(visitId) {
  try { sessionStorage.removeItem(key(visitId)); } catch { /* ignore */ }
}
